import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { QuickMenuItems } from 'src/app/shared/models/quick-menu-items/quick-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-quick-menu',
  templateUrl: './quick-menu.component.html',
  styleUrls: ['./quick-menu.component.scss'],
})

/**
 * Quick menu component
 */
export class QuickMenuComponent {
  @Input() quickMenuItems: QuickMenuItems = new QuickMenuItems();
  RoutesKeys = RoutesKeys;
  quickMenuLabel = 'quick-menu';

  /**
   * @constructor
   */
  constructor(private router: Router) {}

  /**
   * Navigate to router
   * @param {RoutesKeys} route
   */
  onRoute(route: RoutesKeys) {
    this.router.navigate([route]);
  }
}
